(() => {
  'use strict';
  if (window.NLVMarketingSignup) { window.NLVMarketingSignup.init(document); return; }
  const instances = new Map();
  const dismissalKey = 'nlv-marketing-dismissed:v1';
  const init = scope => scope.querySelectorAll('[data-marketing-signup]').forEach(element => {
    if (instances.has(element)) return;
    const dialog = element.querySelector('[data-marketing-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') { element.remove(); return; }
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const pendingKey = `nlv-marketing-email:${element.dataset.signupId}`;
    const editor = element.dataset.signupEditor === 'true' || Boolean(window.Shopify?.designMode);
    let timer, observer, disposed = false, opened = false, ready = false, previousFocus, previousOverflow = '', responseFocus, requestedFocus, manualRequested = false;
    const privacyPresent = () => Boolean(document.querySelector('[data-nlv-privacy]'));
    const busy = () => Boolean(document.querySelector('[data-intro]:not([hidden]), dialog[open]:not([data-marketing-dialog]), [data-purchase-toast]:not([hidden])')) || privacyPresent() && (!window.NLVPrivacy?.ready || window.NLVPrivacy.nativeVisible());
    const remember = () => { if (!editor) { try { localStorage.setItem(dismissalKey, String(Date.now())); } catch (_) {} } };
    const dismissedRecently = () => {
      try { const stamp = Number(localStorage.getItem(dismissalKey)); return stamp > 0 && Date.now() - stamp >= 0 && Date.now() - stamp < 7 * 86400000; } catch (_) { return false; }
    };
    const open = () => {
      if (disposed || dialog.open || busy() || document.visibilityState !== 'visible') return false;
      clearTimeout(timer);
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      opened = true;
      if (responseFocus || requestedFocus === 'signup') { const optional = dialog.querySelector('[data-optional-signup]'); if (optional) optional.open = true; }
      (responseFocus || (requestedFocus === 'cookies' ? dialog.querySelector('[data-cookie-heading]') : null) || dialog.querySelector('[data-marketing-close]'))?.focus({ preventScroll: true });
      return true;
    };
    const close = () => { if (dialog.open) dialog.close(); };
    const attempt = () => {
      if (disposed || !ready || opened && !manualRequested) return;
      if (!manualRequested && !responseFocus) {
        if (window.NLVPrivacy?.nativeHandled) return;
        if ((dismissedRecently() || element.dataset.signupAuto !== 'true') && !window.NLVPrivacy?.needsChoice()) return;
      }
      if (open()) manualRequested = false;
    };
    const trigger = () => { ready = true; attempt(); };
    dialog.addEventListener('close', () => {
      if (dialog.dataset.privacyYield === 'true') { delete dialog.dataset.privacyYield; opened = false; }
      else remember();
      if (!document.querySelector('dialog[open]') && !document.querySelector('[data-intro]:not([hidden])')) {
        document.body.style.overflow = previousOverflow;
        previousFocus?.focus?.({ preventScroll: true });
      }
    }, options);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }, options);
    element.querySelectorAll('[data-marketing-close]').forEach(button => button.addEventListener('click', close, options));
    document.addEventListener('click', event => {
      const button = event.target.closest?.('[data-open-marketing]');
      if (!button || (button.dataset.signupTarget && button.dataset.signupTarget !== element.dataset.signupId)) return;
      event.preventDefault();
      requestedFocus = 'signup'; manualRequested = true; ready = true; attempt();
    }, options);
    document.addEventListener('nlv:privacy:open', () => { requestedFocus = 'cookies'; manualRequested = true; ready = true; attempt(); }, options);
    document.addEventListener('nlv:privacy:ready', attempt, options);
    element.querySelector('[data-signup-sms]')?.addEventListener('click', remember, options);
    element.querySelector('.nlv-signup-form')?.addEventListener('submit', event => {
      if (!event.target.checkValidity()) return;
      try { sessionStorage.setItem(pendingKey, '1'); } catch (_) {}
      remember();
    }, options);
    observer = new MutationObserver(attempt);
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['hidden', 'open'] });
    document.addEventListener('visibilitychange', attempt, options);
    let pending = false;
    try { pending = sessionStorage.getItem(pendingKey) === '1'; sessionStorage.removeItem(pendingKey); } catch (_) {}
    const returnedForm = dialog.querySelector('[data-signup-form-success], [data-signup-form-errors]');
    if (returnedForm && (pending || location.hash === `#MarketingSignupForm-${element.dataset.signupId}`)) {
      // Surface Shopify's actual response, including validation errors, after navigation.
      responseFocus = returnedForm;
      timer = setTimeout(trigger, 200);
    } else if (!editor && (privacyPresent() || element.dataset.signupAuto === 'true' && !dismissedRecently())) {
      const delay = Math.max(1, Math.min(6, Number(element.dataset.signupDelay) || 6)) * 1000;
      const elapsed = scope === document ? performance.now() : 0;
      timer = setTimeout(trigger, Math.max(0, delay - elapsed));
      let lastY = window.scrollY, lastAt = -Infinity, distance = 0, counted = false, gestures = 0;
      window.addEventListener('scroll', () => {
        const y = window.scrollY, moved = Math.abs(y - lastY), now = performance.now();
        lastY = y;
        if (disposed || opened || ready || !moved || busy() || document.visibilityState !== 'visible') return;
        // Momentum emits many events. Require two separated gestures with real movement.
        if (now - lastAt >= 250) { distance = 0; counted = false; }
        lastAt = now;
        distance += moved;
        if (!counted && distance >= 24) { counted = true; gestures += 1; if (gestures >= 2) trigger(); }
      }, { ...options, passive: true });
    }
    instances.set(element, {
      open,
      dispose: () => { disposed = true; clearTimeout(timer); observer.disconnect(); close(); abort.abort(); instances.delete(element); }
    });
  });
  window.NLVMarketingSignup = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:select', event => {
    event.target.querySelectorAll('[data-marketing-signup]').forEach(element => instances.get(element)?.open());
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-marketing-signup]').forEach(element => instances.get(element)?.dispose());
  });
})();
